import { MatSort } from '@angular/material/sort';
import { RepoPosition } from 'src/app/models/repo-business/repo-business.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class RepoPositionListDataSource extends MatDataSource<RepoPosition> {
  public constructor(data: RepoPosition[], sort: MatSort, disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }


  setFilterPredicate(): void {
    this.filterPredicate = (contact: RepoPosition, filterValue: string = '') => {
      const search = filterValue.trim().toLowerCase();
      const regex = new RegExp(search, 'gi');

      return (
        // check simple string fields
        ['positionName']
          .some((key) => {
            const value = contact[key as keyof RepoPosition];
            return value && regex.test(String(value).toLowerCase());
          })
      );
    };
  }

}
